var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex flex-col items-stretch space-y-4 task-box"
  }, [_c('div', [_c('div', {
    staticClass: "flex items-center",
    class: _vm.alignCenter ? 'justify-center' : 'justify-start'
  }, [_c('div', {
    staticClass: "w-10 checkmark",
    class: _vm.checked ? 'color-mint' : 'unchecked'
  }, [_c('svg', {
    attrs: {
      "width": "21",
      "height": "15",
      "viewBox": "0 0 21 15",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18.126 0.455205L6.61231 11.0499L2.91071 7.47097C2.24715 6.82939 1.16751 6.82939 0.500362 7.47097C-0.166787 8.11255 -0.166787 9.15642 0.500362 9.80147L5.37845 14.5179C5.71202 14.8405 6.14603 15 6.58362 15C7.00686 15 7.43011 14.8474 7.75651 14.5457L20.4718 2.84119C21.1533 2.21348 21.1784 1.16961 20.5292 0.510693C19.88 -0.148227 18.8075 -0.172503 18.126 0.455205Z",
      "fill": "currentColor"
    }
  })])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _vm.subtitle ? _c('p', {
    staticClass: "mt-1",
    class: _vm.alignCenter ? 'ml-0 text-center' : 'ml-10 sm-md:ml-0'
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.subtitle) + "\n\t\t")]) : _vm._e()]), _vm._v(" "), _vm.detailsTitle || _vm.detailsSubtitle ? _c(_vm.detailsLink ? 'a' : 'span', {
    tag: "a",
    class: _vm.alignCenter && 'self-center justify-self-center',
    attrs: {
      "href": _vm.detailsLink,
      "target": "blank"
    }
  }, [_c('detail-box', {
    class: _vm.alignCenter ? 'ml-0' : 'ml-10 sm-md:ml-0',
    attrs: {
      "logo": _vm.detailsLogo,
      "title": _vm.detailsTitle,
      "subtitle": _vm.detailsSubtitle
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.buttonText || !_vm.buttonShow ? _c('button', {
    key: _vm.buttonText,
    staticClass: "arrow-button",
    class: _vm.alignCenter ? 'text-center mx-auto' : 'ml-10 sm-md:ml-0',
    on: {
      "click": _vm.buttonAction
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.buttonText) + "\n\t\t")]) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };